(function() {
  function activate(placeholder) {
    if (placeholder.dataset.activated === 'true') return;
    placeholder.dataset.activated = 'true';

    const sources = JSON.parse(placeholder.dataset.sources || '[]');
    if (!sources.length) return;

    const video = document.createElement('video');
    video.className = placeholder.dataset.videoClass || 'w-full h-full object-cover';
    video.muted = true;
    video.loop = placeholder.dataset.loop !== 'false';
    video.playsInline = true;
    video.autoplay = true;
    video.controls = placeholder.dataset.controls === 'true';
    video.setAttribute('preload', 'metadata');
    if (placeholder.dataset.poster) video.setAttribute('poster', placeholder.dataset.poster);

    sources.forEach(s => {
      const src = document.createElement('source');
      src.src = s.url;
      src.type = s.mime || 'video/mp4';
      video.appendChild(src);
    });

    const overlay = placeholder.querySelector('[data-lazy-video-overlay]');
    if (overlay) overlay.remove();

    const poster = placeholder.querySelector('img');
    if (poster) poster.replaceWith(video);
    else placeholder.appendChild(video);

    video.play().catch(() => { });
  }

  document.addEventListener('click', function(e) {
    const placeholder = e.target.closest('[data-lazy-video]');
    if (!placeholder) return;
    e.preventDefault();
    activate(placeholder);
  }, { passive: false });

  function observeAutoplay() {
    const targets = document.querySelectorAll('[data-lazy-video][data-autoplay="true"]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(activate);
      return;
    }
    const io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        activate(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '200px' });
    targets.forEach(function(t) { io.observe(t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAutoplay);
  } else {
    observeAutoplay();
  }
})();
